module.exports = __webpack_public_path__ + "static/MichaelGrive-b4f6a4da0a4deaaa5605cd631f4b1bcc.jpg";